<template>
  <b-modal
    id="change-role-modal"
    ref="changeMemberRoleModal"
    modal-class="invitation"
    title="Change Team Member Role"
    hide-footer
    size="md">
    <label
      class="col-form-label pt-0">
      Role
    </label>
    <b-form-group>
      <b-select
        v-model="role"
        :options="roles"
        value-field="alias"
        text-field="name"
        placeholder="Role"/>
      <span
        v-if="validationErrors.role"
        class="validation-error">{{ validationErrors.role }}</span>
    </b-form-group>
    <span
      v-if="errorMessage"
      class="error-message">
      {{ errorMessage }}
    </span>
    <b-button
      :class="{loading: saving}"
      :disabled="saving"
      class="btn-round btn-block mt-4 mb-4"
      @click="changeRole">
      <span v-if="!saving">Save</span>
      <div class="loader"><div class="loading-circle"/></div>
    </b-button>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import roles from '@/helpers/lists/roles';
import setValidationErrors from '@/helpers/validationErrors';

export default {
  name: 'MemberChangeRoleModal',
  props: {
    memberp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      roles,
      role: 'member',
      saving: false,
      errorMessage: '',
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      apiError: 'merchant/apiError',
    }),
    memberRoleChanged: {
      get() {
        return this.$store.state.merchant.memberRoleChanged;
      },
      set(val) {
        this.$store.state.merchant.memberRoleChanged = val;
      },
    },
  },
  watch: {
    memberRoleChanged(changed) {
      if (changed) {
        this.saving = false;
        this.$emit('roleChanged', changed);

        this.hide();
      }
    },
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  methods: {
    ...mapActions({
      changeMemberRole: 'merchant/changeMemberRole',
    }),
    changeRole() {
      this.saving = true;
      const payload = {
        merchant_id: this.$route.params.merchant_id,
        member_id: this.memberp.id,
        data: {
          role: this.role,
        },
      };
      this.changeMemberRole(payload);
    },
    show() {
      this.role = this.memberp.role;
      this.$refs.changeMemberRoleModal.show();
    },
    hide() {
      Object.assign(this.$data, this.$options.data.apply(this));
      this.memberRoleChanged = false;
      this.$refs.changeMemberRoleModal.hide();
    },
  },
};
</script>
